import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IMemberShipPlan,
  IMemberShipPlanInitialState,
} from "./membershipplanModel";
import {
  createMembershipPlan,
  deleteMembershipPlan,
  getAllMemberShipPlans,
  getMembershipPlanById,
  MembershipPlanActiveInactive,
  updateMembershipPlan,
} from "./services/membershipplan.services";

const initialState: IMemberShipPlanInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  MemberShipPlanList: [],
  MemberShipPlanID: null,
  MemberShipPlanDetail: {
    ID: null,
    PlanName: "",
    BussinessValue: null,
    TicketCount: null,
    DomesticFlightCharge: null,
    InternationalFlightCharge: null,
    IsActive: 1,
  },
};

const membershipPlanSlice = createSlice({
  name: "membershipPlan",
  initialState,
  reducers: {
    clearMemberShipPlanDetails: (state) => {
      state.MemberShipPlanDetail = initialState.MemberShipPlanDetail;
    },
    setMemberShipPlanID: (state, action) => {
      state.MemberShipPlanID = action.payload;
    },
    clearMemberShipPlanID: (state) => {
      state.MemberShipPlanID = initialState.MemberShipPlanID;
    },
  },
  extraReducers: (builder) => {
    /* For getAll Cities */
    builder.addCase(getAllMemberShipPlans.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllMemberShipPlans.fulfilled,
      (state, action: PayloadAction<IMemberShipPlan[]>) => {
        state.loading = false;
        state.MemberShipPlanList = action.payload || [];
      }
    );
    builder.addCase(getAllMemberShipPlans.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MemberShipPlanList = [];
    });

    /* For getPromoCodeBy ID */
    builder.addCase(getMembershipPlanById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getMembershipPlanById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.MemberShipPlanDetail = action.payload;
    });
    builder.addCase(getMembershipPlanById.rejected, (state, action) => {
      state.formLoading = false;
      state.MemberShipPlanDetail = initialState.MemberShipPlanDetail;
      state.error = action.error.message || "Something went wrong";
    });

    /* For create PromoCode */
    builder.addCase(createMembershipPlan.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createMembershipPlan.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createMembershipPlan.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Update PromoCode */
    builder.addCase(updateMembershipPlan.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateMembershipPlan.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateMembershipPlan.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Delete Cities */
    builder.addCase(deleteMembershipPlan.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMembershipPlan.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMembershipPlan.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For PromoCodeActiveInactive */
    builder.addCase(MembershipPlanActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(MembershipPlanActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(MembershipPlanActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearMemberShipPlanID,
  clearMemberShipPlanDetails,
  setMemberShipPlanID,
} = membershipPlanSlice.actions;
export default membershipPlanSlice.reducer;
